import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PriceService {

constructor(private http:HttpClient) { }

GetPriceAlphabet(price:String):Observable<any>{
  return this.http.get(environment.BaseUrl + "Daro/Price/GetPriceAlphabet?price="+price).pipe(
    map(data=>{
      return data as any
    })
  )
}

}
